import { ArrowRightOutlined } from "@ant-design/icons";
import { Card, Col, Row, Space, Typography } from "antd";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router";
import { SETTINGS_MODULES } from "./settings.constants";
import { getSettingsModuleIcon } from "./settings.utils";

import "./settings.css";

const { Text } = Typography;

const SettingsModuleCard = memo(function SettingsModuleCard({ module, icon, onNavigate }) {
  const handleClick = useCallback(() => {
    console.log("Navigating to:", module.route);
    onNavigate(module.route);
  }, [module.route, onNavigate]);

  return (
    <Card className="settings-module-card" bordered={false} onClick={handleClick}>
      <div className="settings-module-content">
        <div className={`settings-card-icon ${module.iconClassName}`}>{icon}</div>
        <div className="settings-card-main">
          <Space direction="vertical" size={8} className="settings-card-text-stack">
            <Text className="settings-card-title">{module.title}</Text>
            <Text className="settings-card-description">{module.description}</Text>
          </Space>
        </div>
        <ArrowRightOutlined className="settings-card-arrow" />
      </div>
    </Card>
  );
});

export function SettingsPage() {
  const navigate = useNavigate();

  const handleNavigate = useCallback(
    (route) => {
      console.log("Navigating to:", route);
      navigate(route);
    },
    [navigate],
  );

  return (
    <div className="settings-page">
      <Row gutter={[20, 20]}>
        {SETTINGS_MODULES.map((module) => (
          <Col key={module.key} xs={24} sm={24} md={12} lg={8}>
            <SettingsModuleCard
              module={module}
              icon={getSettingsModuleIcon(module.iconKey)}
              onNavigate={handleNavigate}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
